import { render, staticRenderFns } from "./NonConformityCorrectiveAction.vue?vue&type=template&id=6f8503fa&scoped=true"
import script from "./NonConformityCorrectiveAction.vue?vue&type=script&lang=js"
export * from "./NonConformityCorrectiveAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f8503fa",
  null
  
)

export default component.exports